/**
 * Detects if the given text contains RTL (Right-to-Left) script characters.
 * Currently supports Arabic, Hebrew, and Persian.
 * @param {string} text - The text to check
 * @returns {boolean} True if the text contains RTL characters, false otherwise
 */
export const isRTL = (text) => {
  if (!text || typeof text !== 'string') return false;

  // RTL Unicode ranges:
  // Arabic: \u0600-\u06FF, \u0750-\u077F, \u08A0-\u08FF, \uFB50-\uFDFF, \uFE70-\uFEFF
  // Hebrew: \u0590-\u05FF
  // Persian: \u0600-\u06FF, \u0750-\u077F, \u08A0-\u08FF, \uFB50-\uFDFF, \uFE70-\uFEFF
  const rtlPattern = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;

  return rtlPattern.test(text);
};

/**
 * Gets the text direction ('rtl' or 'ltr') based on the content.
 * @param {string} text - The text to check
 * @returns {'rtl'|'ltr'} The text direction
 */
export const getTextDirection = (text) => {
  if (!text || typeof text !== 'string') return 'ltr';
  // Find the first strong directional character (for prompt input alignment)
  for (let char of text) {
    if (/[A-Za-z]/.test(char)) return 'ltr'; // English/Latin
    if (/[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/.test(char)) return 'rtl'; // RTL
    // Add more LTR/RTL scripts if needed 
  }
  return 'ltr'; // Default
};